import styled from "styled-components";
import styles from "../styles";

const S = {
	PdfPreview: styled.div`
      font-size: ${styles.fontSizes.default}px;
      background: ${styles.colors.previewBackground};
      max-width: 1000px;
      min-width: 600px;
      width: 100vw;
      overflow: hidden;
      margin: auto;
      text-align: justify;
    `,
};

export default ({ children }: { children: any }) => (
	<S.PdfPreview>{children}</S.PdfPreview>
);
